type AnalyticsValue = string | number | boolean | null | undefined;

type AnalyticsParams = Record<string, AnalyticsValue>;

type AnalyticsPayload = Record<string, AnalyticsValue>;

declare global {
    interface Window {
        dataLayer?: AnalyticsPayload[];
    }
}

const BLOCKED_PARAM_PATTERNS = [
    /email/iu,
    /phone/iu,
    /name/iu,
    /password/iu,
    /card/iu,
    /wallet/iu,
    /address/iu,
    /payment/iu
];

const isBlockedParam = (key: string): boolean => BLOCKED_PARAM_PATTERNS.some(pattern => pattern.test(key));

const sanitizeAnalyticsParams = (params: AnalyticsParams): AnalyticsParams => Object.entries(params).reduce(
    (acc: AnalyticsParams, [key, value]) => {
        if (isBlockedParam(key) || typeof value === 'undefined' || value === null) {
            return acc;
        }

        acc[key] = value;

        return acc;
    },
    {}
);

/**
 * Sends GA4-compatible events through GTM dataLayer without personal data.
 */
export const pushAnalyticsEvent = (event: string, params: AnalyticsParams = {}): void => {
    if (typeof window === 'undefined' || !event) {
        return;
    }

    window.dataLayer ||= [];
    window.dataLayer.push({
        event,
        ...sanitizeAnalyticsParams(params)
    });
};
